var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareersHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 677,
    height: 480,
    viewBox: "0 0 677 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M308.788 207.227C335.379 191.575 344.651 156.241 320.846 136.609C311.016 128.502 300.202 121.557 288.606 115.959C260.108 102.202 228.17 97.2046 196.832 101.599C165.493 105.993 136.161 119.581 112.546 140.646C88.93 161.71 72.0909 189.304 64.1579 219.938C56.2248 250.573 57.5541 282.872 67.9777 312.751C78.4012 342.63 97.4508 368.747 122.718 387.8C147.984 406.852 178.333 417.984 209.927 419.788C222.782 420.523 235.608 419.699 248.138 417.382C278.479 411.772 287.523 376.379 271.871 349.788L257.951 326.141C249.987 312.61 231.972 309.128 216.297 308.233V308.233C206.767 307.689 197.613 304.331 189.991 298.584C182.37 292.837 176.623 284.959 173.479 275.946C170.335 266.933 169.934 257.19 172.327 247.95C174.72 238.709 179.799 230.386 186.923 224.032C194.046 217.678 202.894 213.579 212.347 212.254C221.8 210.928 231.434 212.436 240.03 216.585V216.585C254.17 223.411 271.61 229.11 285.141 221.146L308.788 207.227Z",
    fill: "url(#paint0_linear_1648_474)",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M481.47 376.755L473.181 375.546V333.592L481.47 334.502V376.755Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M667.803 354.911L286.826 313.193V74.6508L667.803 23.7867V354.911Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M671.057 23.3589L283.552 75.1108C280.879 75.4745 278.703 74.0411 278.703 71.8054V68.1578C278.703 66.0184 280.879 63.879 283.552 63.4939L671.057 7.1316C673.73 6.73581 675.906 8.91799 675.906 11.9987V17.1333C675.931 18.5928 675.46 20.0153 674.573 21.1529C673.687 22.2905 672.443 23.0712 671.057 23.3589V23.3589Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M660.727 12.9937L667.503 11.9882",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M642.522 15.6893L652.884 14.1596",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M318.894 63.323L636.409 16.5666",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M287.127 68.0084L310.698 64.5319",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M514.707 319.548L449.909 313.525V219.039L514.759 218.889L514.707 319.548Z",
    fill: "#7846D1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M514.707 319.548L449.909 313.525V219.039L514.759 218.889L514.707 319.548Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M579.557 325.57L514.707 319.548V218.932L579.557 218.793V325.57Z",
    fill: "#7846D1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M579.557 325.571L514.707 319.548V218.933L579.557 218.794V325.571Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M644.397 331.593L579.558 325.57V218.75L644.397 218.601V331.593Z",
    fill: "#7846D1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M644.397 331.593L579.558 325.57V218.75L644.397 218.601V331.593Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M644.397 218.601L449.909 219.039",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M449.909 232.539L644.449 234.743",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M644.397 250.884L449.909 246.038",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M449.909 259.581L644.449 267.068",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M644.397 283.168L449.909 273.027",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M449.909 286.527L644.449 299.31",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M644.397 315.451L449.909 300.026",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M449.909 313.525L644.449 331.593",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M466.072 315.034V218.997",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M449.909 219.039V313.526",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M498.492 318.039V218.932",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M482.288 218.932V316.499",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M530.923 321.056V218.857",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M514.707 218.932V319.591",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M563.343 324.062V218.783",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M547.127 218.814V322.575",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M595.763 327.079V218.708",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M579.558 218.751V325.57",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M628.192 330.084V218.633",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M611.978 218.676V328.587",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M644.397 218.601V331.593",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M449.909 219.039V313.525L644.449 331.593V218.601L449.909 219.039Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M457.97 313.868L453.101 313.419V286.323L457.97 286.644V313.868Z",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M462.829 314.328L457.97 313.868V273.048L462.829 273.305V314.328Z",
    fill: "#7846D1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M474.175 315.376L469.315 314.927V266.79L474.175 267.004V315.376Z",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M479.044 315.825L474.175 315.376V260.062L479.044 260.244V315.825Z",
    fill: "#7846D1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M490.39 316.874L485.53 316.424V274.471L490.39 274.728V316.874Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M495.249 317.344L490.39 316.895V267.689L495.249 267.903V317.344Z",
    fill: "#7846D1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M506.605 318.414L501.735 317.965V289.532L506.605 289.853V318.414Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M511.465 318.82L506.605 318.371V284.141L511.465 284.43V318.82Z",
    fill: "#7846D1",
    stroke: "#7846D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M522.81 319.869L517.95 319.419V270.716L522.81 270.941V319.869Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M527.679 320.318L522.81 319.869V280.162L527.679 280.429V320.318Z",
    fill: "#7846D1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M539.015 321.366L534.155 320.917V278.685L539.015 278.942V321.366Z",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M543.885 321.816L539.025 321.366V271.69L543.885 271.914V321.816Z",
    fill: "#7846D1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M555.24 322.864L550.37 322.414V269.614L555.24 269.828V322.864Z",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M560.1 323.313L555.24 322.864V273.776L560.1 274.011V323.313Z",
    fill: "#7846D1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M571.444 324.362L566.585 323.912V258.875L571.444 259.046V324.362Z",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M576.314 324.832L571.444 324.372V251.312L576.314 251.451V324.832Z",
    fill: "#7846D1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M587.712 325.902L582.853 325.453V264.202L587.712 264.384V325.902Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M592.519 260.811V326.319L587.712 325.902V260.65L592.519 260.811Z",
    fill: "#7846D1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M603.875 327.368L599.005 326.918V256.532L603.875 256.682V327.368Z",
    fill: "#263238"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M608.734 327.817L603.875 327.367V258.137L608.734 258.286V327.817Z",
    fill: "#7846D1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M620.08 328.865L615.221 328.416V246.745L620.08 246.852V328.865Z",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M624.95 329.314L620.08 328.865V242.348L624.95 242.433V329.314Z",
    fill: "#7846D1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M636.295 330.362L631.425 329.913V234.122L636.295 234.175V330.362Z",
    fill: "#263238"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M641.154 330.811L636.295 330.362V230.121H641.154V330.811Z",
    fill: "#7846D1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M516.086 269.582L501.984 268.941C501.213 268.945 500.467 268.653 499.893 268.121C499.318 267.589 498.956 266.855 498.876 266.063V256.778C498.908 256.393 499.015 256.018 499.189 255.676C499.364 255.334 499.603 255.031 499.893 254.786C500.183 254.541 500.517 254.358 500.876 254.248C501.235 254.138 501.612 254.104 501.984 254.147L516.086 254.585C516.861 254.566 517.615 254.853 518.192 255.388C518.77 255.922 519.128 256.665 519.194 257.463V266.94C519.166 267.327 519.062 267.705 518.889 268.05C518.716 268.394 518.477 268.7 518.186 268.946C517.896 269.193 517.56 269.377 517.199 269.486C516.838 269.595 516.459 269.628 516.086 269.582V269.582Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M502.938 265.389C502.46 265.32 502.025 265.069 501.718 264.684C501.411 264.3 501.255 263.811 501.28 263.314V262.789H502.731V263.431C502.731 263.955 503.031 264.191 503.518 264.212C504.005 264.234 504.305 264.02 504.305 263.474C504.305 262.929 504.026 262.404 503 261.666C501.757 260.757 501.321 260.062 501.321 259.131C501.305 258.896 501.333 258.659 501.405 258.435C501.478 258.211 501.592 258.004 501.743 257.826C501.893 257.647 502.076 257.502 502.281 257.397C502.486 257.293 502.709 257.231 502.938 257.216V256.478H504.181V257.216C504.656 257.283 505.089 257.533 505.393 257.916C505.697 258.299 505.849 258.787 505.818 259.281V259.58H504.378V259.249C504.39 259.142 504.378 259.034 504.344 258.933C504.309 258.832 504.253 258.741 504.179 258.666C504.105 258.59 504.015 258.533 503.917 258.499C503.819 258.465 503.714 258.454 503.611 258.468C503.124 258.468 502.855 258.671 502.855 259.163C502.855 259.655 503.135 260.158 504.16 260.918C505.404 261.848 505.839 262.533 505.839 263.517C505.859 263.759 505.831 264.003 505.758 264.234C505.685 264.465 505.567 264.679 505.413 264.863C505.258 265.046 505.07 265.196 504.858 265.303C504.647 265.41 504.416 265.472 504.181 265.485V266.341H502.938V265.389Z",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M514.387 262.501V256.885L511.009 256.767V262.362L508.595 262.276C510.242 264.191 511.061 265.153 512.739 267.079L516.832 262.586L514.387 262.501Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M606.061 247.814L591.949 247.483C591.153 247.484 590.386 247.169 589.808 246.604C589.229 246.039 588.883 245.266 588.841 244.445V234.336C588.876 233.521 589.223 232.753 589.806 232.201C590.388 231.65 591.159 231.36 591.949 231.394L606.061 231.523C606.859 231.522 607.627 231.838 608.206 232.405C608.784 232.973 609.129 233.748 609.169 234.571V244.841C609.159 245.248 609.069 245.649 608.907 246.02C608.744 246.392 608.511 246.726 608.221 247.003C607.932 247.28 607.591 247.494 607.22 247.634C606.849 247.773 606.455 247.834 606.061 247.814V247.814Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M592.892 243.589C592.399 243.5 591.956 243.223 591.651 242.813C591.346 242.403 591.201 241.889 591.245 241.374V240.765H592.685V241.471C592.674 241.582 592.687 241.694 592.723 241.799C592.759 241.905 592.817 242 592.894 242.079C592.97 242.158 593.063 242.219 593.165 242.256C593.267 242.293 593.375 242.306 593.483 242.294C593.591 242.311 593.701 242.301 593.805 242.265C593.909 242.23 594.003 242.169 594.079 242.089C594.156 242.009 594.213 241.911 594.246 241.803C594.28 241.696 594.288 241.582 594.27 241.471C594.27 240.808 593.991 240.326 592.965 239.545C591.722 238.583 591.286 237.834 591.286 236.828C591.236 236.327 591.374 235.824 591.674 235.426C591.973 235.027 592.409 234.763 592.892 234.689V233.908H594.146V234.721C594.638 234.803 595.081 235.075 595.385 235.483C595.689 235.89 595.832 236.402 595.783 236.914V237.171H594.343V236.807C594.359 236.697 594.351 236.585 594.319 236.479C594.287 236.373 594.232 236.276 594.158 236.196C594.084 236.115 593.993 236.053 593.892 236.014C593.791 235.976 593.683 235.961 593.576 235.972C593.472 235.958 593.367 235.969 593.267 236.004C593.168 236.039 593.078 236.097 593.004 236.173C592.93 236.25 592.874 236.343 592.84 236.445C592.806 236.548 592.796 236.657 592.81 236.764C592.81 237.374 593.089 237.834 594.115 238.636C595.369 239.599 595.804 240.348 595.804 241.407C595.846 241.915 595.697 242.42 595.388 242.818C595.08 243.216 594.635 243.476 594.146 243.546V244.466H592.892V243.589Z",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M600.974 239.053V245.129L604.351 245.204V239.107H606.765L602.621 233.993L598.528 238.978L600.974 239.053Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M544.993 164.303C549.322 165.262 553.747 165.682 558.172 165.555C583.091 164.859 605.719 145.541 605.833 120.307C605.906 96.1207 582.335 77.6578 558.172 81.2306V123.398C553.807 137.047 549.414 150.682 544.993 164.303Z",
    fill: "#7846D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M558.172 123.398V81.2307C534.912 83.691 510.169 102.528 510.511 126.479C510.801 144.546 526.385 160.934 544.952 164.303C549.407 150.675 553.814 137.04 558.172 123.398Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M540.89 106.186C540.86 105.807 540.753 105.438 540.576 105.104C540.399 104.77 540.156 104.478 539.863 104.248C539.57 104.017 539.233 103.852 538.875 103.764C538.516 103.676 538.144 103.667 537.781 103.737C537.003 103.751 536.257 104.059 535.684 104.604C535.111 105.148 534.751 105.89 534.673 106.689V108.379C534.705 108.758 534.812 109.126 534.99 109.46C535.167 109.794 535.409 110.085 535.702 110.317C535.994 110.548 536.33 110.714 536.688 110.804C537.046 110.894 537.418 110.906 537.781 110.84C538.559 110.825 539.306 110.517 539.878 109.973C540.451 109.429 540.811 108.687 540.89 107.887",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M532.238 138.705V144.171C532.261 144.425 532.334 144.672 532.451 144.896C532.569 145.12 532.73 145.317 532.924 145.475C533.117 145.633 533.34 145.749 533.579 145.815C533.817 145.882 534.066 145.897 534.31 145.862V145.862C534.821 145.865 535.315 145.674 535.698 145.324C536.08 144.975 536.324 144.492 536.383 143.968V130.201C536.407 129.845 536.556 129.509 536.802 129.257C537.048 129.006 537.374 128.854 537.719 128.832C537.89 128.795 538.066 128.796 538.236 128.834C538.407 128.873 538.567 128.948 538.707 129.055C538.847 129.162 538.963 129.299 539.049 129.456C539.134 129.613 539.186 129.787 539.201 129.966V143.872C539.222 144.127 539.294 144.374 539.411 144.6C539.528 144.825 539.689 145.023 539.883 145.182C540.077 145.342 540.3 145.458 540.539 145.525C540.778 145.593 541.028 145.609 541.273 145.573C541.785 145.576 542.281 145.383 542.663 145.032C543.046 144.68 543.289 144.194 543.345 143.669V130.319",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M532.238 135.122V136.726",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M543.325 128.372V117.525C543.343 117.354 543.422 117.196 543.546 117.081C543.67 116.966 543.831 116.904 543.998 116.905V116.905C544.076 116.891 544.156 116.894 544.233 116.914C544.31 116.934 544.382 116.971 544.444 117.021C544.506 117.071 544.558 117.135 544.595 117.207C544.633 117.279 544.655 117.358 544.661 117.439V123.858C544.68 124.248 544.847 124.616 545.127 124.88C545.406 125.144 545.775 125.284 546.153 125.27C546.593 125.303 547.027 125.158 547.366 124.867C547.704 124.576 547.919 124.16 547.967 123.708V115.974C547.967 113.942 546.091 112.433 543.77 112.604L531.793 113.503C529.472 113.685 527.648 115.439 527.648 117.439V124.927C527.67 125.315 527.839 125.679 528.118 125.939C528.397 126.199 528.765 126.335 529.14 126.318C529.577 126.354 530.01 126.214 530.349 125.926C530.687 125.639 530.904 125.227 530.954 124.778V118.359C530.971 118.187 531.05 118.028 531.174 117.911C531.298 117.795 531.459 117.73 531.627 117.728V117.728C531.705 117.716 531.784 117.721 531.86 117.741C531.937 117.762 532.008 117.799 532.07 117.849C532.132 117.899 532.183 117.961 532.221 118.033C532.259 118.104 532.283 118.182 532.29 118.263V133.496",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M581.423 104.144C581.64 105.492 581.961 107.438 581.961 107.438L574.563 108.005C574.563 108.005 575.247 103.727 575.299 103.406C575.422 102.643 575.775 101.939 576.306 101.393C576.838 100.848 577.522 100.49 578.262 100.368C578.974 100.346 579.668 100.595 580.214 101.066C580.76 101.537 581.12 102.198 581.226 102.924",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M587.815 121.109V113.118C587.815 110.979 585.93 109.449 583.619 109.62",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M583.174 133.892V131.218L585.536 131.078C584.593 124.543 584.117 121.269 583.174 114.755C583.187 114.581 583.261 114.418 583.384 114.297C583.506 114.177 583.668 114.107 583.837 114.102C583.916 114.09 583.997 114.096 584.075 114.118C584.152 114.14 584.224 114.178 584.287 114.23C584.349 114.282 584.4 114.348 584.437 114.421C584.474 114.495 584.495 114.576 584.5 114.659V121.301C584.511 121.7 584.674 122.077 584.953 122.352C585.233 122.626 585.606 122.776 585.992 122.767",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M583.174 137.347V135.497",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M571.269 129.891C571.155 130.683 571.103 131.079 570.989 131.87L573.352 131.731V142.193C573.369 142.452 573.438 142.704 573.553 142.934C573.668 143.165 573.828 143.369 574.021 143.534C574.215 143.699 574.439 143.822 574.68 143.894C574.921 143.967 575.174 143.989 575.424 143.958C575.944 143.96 576.446 143.759 576.83 143.397C577.214 143.034 577.452 142.536 577.496 142V131.496L579.029 131.41V141.915C579.047 142.173 579.116 142.426 579.231 142.656C579.346 142.887 579.505 143.091 579.699 143.256C579.893 143.421 580.117 143.543 580.358 143.616C580.599 143.689 580.852 143.711 581.102 143.68C581.624 143.681 582.127 143.48 582.511 143.115C582.896 142.75 583.132 142.249 583.174 141.711V139.208",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M580.035 109.888L572.906 110.423C571.854 110.46 570.851 110.895 570.087 111.644C569.324 112.393 568.852 113.404 568.762 114.487V122.286C568.775 122.672 568.932 123.037 569.201 123.306C569.469 123.575 569.828 123.727 570.202 123.73C570.648 123.765 571.089 123.618 571.431 123.319C571.772 123.021 571.986 122.596 572.025 122.136V115.504C572.04 115.33 572.116 115.169 572.238 115.048C572.36 114.928 572.52 114.858 572.689 114.851V114.851C572.768 114.839 572.849 114.844 572.926 114.866C573.004 114.888 573.076 114.927 573.138 114.979C573.201 115.031 573.252 115.096 573.289 115.17C573.325 115.244 573.347 115.325 573.352 115.407L571.746 126.639",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M623.208 116.456L617.945 116.809C617.491 116.873 617.03 116.839 616.589 116.71C616.149 116.58 615.739 116.357 615.386 116.055C615.034 115.754 614.746 115.38 614.54 114.957C614.335 114.534 614.217 114.072 614.194 113.6V108.754C614.26 107.759 614.679 106.825 615.371 106.13C616.064 105.435 616.98 105.028 617.945 104.989L623.208 104.582C623.662 104.516 624.124 104.549 624.564 104.678C625.005 104.807 625.415 105.03 625.767 105.332C626.119 105.634 626.406 106.009 626.61 106.432C626.813 106.856 626.929 107.319 626.949 107.791V112.723C626.885 113.713 626.467 114.644 625.776 115.333C625.084 116.023 624.169 116.423 623.208 116.456Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M635.922 112.797L632.71 113.022V111.578C633.943 108.765 634.554 107.363 635.818 104.539L637.652 104.4V111.236H638.44V112.68H637.652V114.52L635.963 114.637L635.922 112.797ZM635.922 111.353V107.417C635.269 109.043 634.938 109.856 634.274 111.471L635.922 111.353Z",
    fill: "#263238"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M639.185 111.963V111.16L640.771 111.053V111.963C640.771 112.69 641.113 112.925 641.651 112.883C642.19 112.84 642.522 112.562 642.522 111.813V109.535C642.522 108.807 642.18 108.55 641.651 108.593C641.123 108.636 640.771 108.925 640.771 109.663V109.748L639.185 109.866C639.31 107.588 639.372 106.454 639.486 104.186L643.92 103.844V105.299L640.988 105.512C640.936 106.486 640.905 106.978 640.854 107.951C641.01 107.699 641.224 107.489 641.477 107.342C641.73 107.195 642.014 107.114 642.304 107.106C643.537 107.021 644.169 107.802 644.169 109.299V111.599C644.2 111.953 644.158 112.311 644.045 112.647C643.932 112.983 643.75 113.29 643.513 113.549C643.276 113.807 642.988 114.01 642.669 114.144C642.349 114.278 642.006 114.34 641.662 114.327C641.339 114.396 641.004 114.384 640.687 114.293C640.369 114.202 640.077 114.034 639.834 113.803C639.592 113.571 639.407 113.284 639.294 112.964C639.181 112.644 639.144 112.301 639.185 111.963Z",
    fill: "#263238"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M645.257 107.844V105.298C645.239 105.07 645.269 104.84 645.343 104.624C645.418 104.408 645.536 104.21 645.689 104.045C645.843 103.879 646.029 103.749 646.235 103.662C646.441 103.576 646.662 103.536 646.884 103.544C647.092 103.497 647.308 103.501 647.514 103.557C647.721 103.614 647.911 103.72 648.069 103.868C648.227 104.015 648.349 104.2 648.424 104.406C648.499 104.612 648.525 104.834 648.5 105.052V107.609C648.519 107.837 648.491 108.067 648.418 108.283C648.345 108.499 648.228 108.696 648.075 108.862C647.922 109.028 647.737 109.159 647.532 109.245C647.326 109.331 647.105 109.372 646.884 109.363C646.674 109.411 646.457 109.406 646.249 109.349C646.042 109.292 645.851 109.185 645.691 109.036C645.532 108.888 645.41 108.702 645.334 108.495C645.259 108.287 645.232 108.064 645.257 107.844V107.844ZM647.433 107.759V105.063C647.433 104.614 647.215 104.443 646.884 104.464C646.552 104.485 646.324 104.699 646.324 105.149V107.844C646.324 108.294 646.531 108.465 646.884 108.443C647.236 108.422 647.433 108.208 647.433 107.759V107.759ZM650.759 103.394L651.795 103.319C650.137 107.534 649.308 109.641 647.65 113.835L646.614 113.909C648.272 109.716 649.101 107.62 650.759 103.405V103.394ZM649.951 112.187V109.631C649.931 109.403 649.959 109.174 650.033 108.958C650.106 108.743 650.223 108.546 650.376 108.381C650.529 108.216 650.714 108.086 650.92 108.001C651.125 107.916 651.346 107.877 651.567 107.887C651.777 107.837 651.995 107.84 652.204 107.896C652.412 107.952 652.605 108.059 652.764 108.208C652.924 108.357 653.047 108.544 653.121 108.753C653.196 108.961 653.221 109.185 653.194 109.406V111.963C653.211 112.191 653.182 112.42 653.108 112.636C653.033 112.851 652.915 113.048 652.761 113.213C652.607 113.378 652.421 113.507 652.215 113.592C652.01 113.677 651.788 113.716 651.567 113.706C651.358 113.754 651.141 113.75 650.933 113.693C650.726 113.636 650.536 113.529 650.377 113.38C650.219 113.231 650.097 113.045 650.023 112.837C649.949 112.63 649.924 112.407 649.951 112.187V112.187ZM652.126 112.112V109.406C652.126 108.957 651.909 108.786 651.567 108.807C651.225 108.828 651.018 109.032 651.018 109.492V112.187C651.018 112.647 651.225 112.818 651.567 112.797C651.909 112.776 652.126 112.572 652.126 112.112V112.112Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M623.208 133.838L617.945 134.116C617.487 134.171 617.023 134.128 616.582 133.99C616.14 133.852 615.731 133.622 615.38 133.314C615.028 133.006 614.741 132.627 614.538 132.2C614.334 131.773 614.217 131.308 614.194 130.832V125.944C614.259 124.955 614.68 124.026 615.374 123.341C616.068 122.656 616.985 122.265 617.945 122.243L623.208 121.911C623.666 121.853 624.13 121.893 624.571 122.03C625.012 122.166 625.421 122.395 625.773 122.702C626.124 123.01 626.41 123.389 626.612 123.816C626.815 124.243 626.929 124.709 626.949 125.184V130.148C626.887 131.135 626.468 132.062 625.775 132.745C625.082 133.429 624.166 133.819 623.208 133.838V133.838Z",
    fill: "#7846D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M633.062 129.881V129.078L634.657 128.993V129.891C634.657 130.619 634.989 130.854 635.528 130.833C636.067 130.811 636.398 130.522 636.398 129.763V127.495C636.398 126.779 636.067 126.522 635.528 126.554C634.989 126.586 634.657 126.875 634.657 127.624V127.709L633.062 127.795L633.373 122.147L637.807 121.869V123.323L634.875 123.495C634.813 124.468 634.792 124.949 634.73 125.912C634.886 125.661 635.101 125.455 635.354 125.311C635.608 125.167 635.891 125.091 636.18 125.088C637.424 125.014 638.045 125.805 638.045 127.292V129.581C638.079 129.934 638.038 130.289 637.926 130.624C637.813 130.958 637.631 131.264 637.392 131.518C637.153 131.773 636.864 131.97 636.544 132.098C636.224 132.225 635.88 132.279 635.538 132.255C635.214 132.325 634.879 132.313 634.56 132.222C634.241 132.13 633.948 131.961 633.706 131.728C633.463 131.496 633.278 131.207 633.166 130.885C633.054 130.564 633.018 130.219 633.062 129.881Z",
    fill: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M639.185 129.538V128.747L640.771 128.651V129.57C640.771 130.287 641.113 130.533 641.651 130.501C642.19 130.469 642.522 130.202 642.522 129.431V127.153C642.522 126.426 642.18 126.169 641.651 126.201C641.123 126.233 640.771 126.522 640.771 127.271V127.356L639.185 127.452C639.31 125.174 639.372 124.04 639.486 121.772L643.92 121.494V122.949L640.988 123.12C640.936 124.094 640.905 124.586 640.854 125.559C641.009 125.308 641.224 125.1 641.477 124.957C641.731 124.813 642.015 124.737 642.304 124.735C643.537 124.661 644.169 125.452 644.169 126.95V129.25C644.203 129.603 644.162 129.96 644.049 130.295C643.936 130.631 643.754 130.937 643.516 131.193C643.278 131.449 642.989 131.649 642.669 131.779C642.349 131.909 642.005 131.965 641.662 131.945C641.335 132.016 640.996 132.004 640.675 131.911C640.353 131.818 640.058 131.646 639.815 131.409C639.572 131.173 639.387 130.879 639.278 130.554C639.168 130.228 639.137 129.88 639.185 129.538Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M645.258 125.537V122.992C645.238 122.763 645.266 122.534 645.34 122.318C645.414 122.102 645.532 121.905 645.687 121.741C645.841 121.576 646.028 121.448 646.235 121.365C646.441 121.282 646.663 121.245 646.884 121.259C647.094 121.213 647.312 121.219 647.518 121.277C647.725 121.336 647.916 121.444 648.074 121.594C648.232 121.744 648.353 121.93 648.427 122.138C648.502 122.345 648.527 122.569 648.501 122.788V125.345C648.52 125.572 648.493 125.8 648.419 126.015C648.346 126.229 648.228 126.425 648.075 126.588C647.921 126.752 647.736 126.879 647.53 126.962C647.325 127.044 647.104 127.08 646.884 127.067C646.674 127.113 646.456 127.106 646.249 127.047C646.042 126.989 645.851 126.881 645.692 126.731C645.534 126.582 645.411 126.396 645.336 126.188C645.26 125.981 645.233 125.758 645.258 125.537ZM647.434 125.484V122.788C647.434 122.328 647.216 122.157 646.884 122.179C646.553 122.2 646.325 122.403 646.325 122.852V125.548C646.325 125.997 646.532 126.179 646.884 126.158C647.237 126.136 647.434 125.933 647.434 125.484V125.484ZM650.759 121.205L651.796 121.141C650.138 125.334 649.309 127.431 647.651 131.603L646.615 131.656C648.273 127.452 649.102 125.356 650.759 121.162V121.205ZM649.951 129.987V127.431C649.932 127.204 649.959 126.976 650.033 126.761C650.106 126.547 650.224 126.351 650.377 126.187C650.531 126.024 650.716 125.897 650.922 125.814C651.127 125.731 651.348 125.695 651.568 125.709C651.779 125.663 651.998 125.67 652.206 125.728C652.414 125.787 652.605 125.897 652.764 126.047C652.923 126.198 653.045 126.385 653.12 126.594C653.195 126.803 653.22 127.028 653.194 127.249V129.816C653.214 130.044 653.186 130.273 653.112 130.489C653.038 130.704 652.919 130.9 652.765 131.064C652.61 131.228 652.423 131.355 652.217 131.437C652.01 131.519 651.789 131.553 651.568 131.538C651.352 131.585 651.129 131.576 650.918 131.514C650.707 131.451 650.513 131.337 650.354 131.18C650.195 131.023 650.075 130.829 650.005 130.613C649.935 130.398 649.916 130.169 649.951 129.945V129.987ZM652.127 129.987V127.281C652.127 126.832 651.91 126.65 651.568 126.671C651.226 126.693 651.018 126.896 651.018 127.345V130.052C651.018 130.501 651.226 130.683 651.568 130.661C651.91 130.64 652.127 130.351 652.127 129.902V129.987Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M369.093 189.238L304.253 190.789V80.8776L369.093 73.1651V189.238Z",
    fill: "#7846D1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M369.093 189.238L304.253 190.789V80.8774L369.093 73.1649V189.238Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M433.984 187.697L369.093 189.237V73.1647L433.943 65.4522L433.984 187.697Z",
    fill: "#7846D1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M433.984 187.697L369.093 189.237V73.1644L433.943 65.4519L433.984 187.697Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M498.834 186.157L433.984 187.697V65.4525L498.834 57.74V186.157Z",
    fill: "#7846D1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M498.834 186.157L433.984 187.698V65.4529L498.834 57.7404V186.157Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M498.834 57.74L304.294 80.8775",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M304.294 96.5805L498.834 76.0851",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M498.834 94.4303L304.294 112.284",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M304.294 128.008L498.834 112.808",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M498.834 131.121L304.294 143.68",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M304.294 159.383L498.834 149.466",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M498.834 167.812L304.294 175.075",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M304.294 190.789L498.834 186.157",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M320.499 190.404V78.9519",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M304.294 80.8773V190.789",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M352.93 189.623V75.0906",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M336.714 77.016V190.051",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M385.35 188.853V71.2397",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M369.093 73.1651V189.238",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M417.79 188.082V67.3776",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M401.564 69.3143V188.468",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M450.199 187.312V63.5268",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M433.984 65.4522V187.697",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M482.619 186.542V59.6759",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M466.404 61.6014V186.927",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M498.834 57.74V186.157",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M304.294 80.878V190.789L498.834 186.158V57.7939L304.294 80.878Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M304.294 175.075H305.454",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M307.434 174.968L318.354 174.562",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.71 1.71"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M319.359 174.519H320.509L321.328 173.685",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M322.944 171.984C327.804 167.01 330.197 164.496 335.088 159.436",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.98 1.98"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M335.938 158.591L336.756 157.735C337.088 158.035 337.253 158.195 337.575 158.505",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M338.828 159.725L343.356 164.004",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.58 1.58"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M343.998 164.656L344.817 165.448C344.972 164.998 345.045 164.774 345.19 164.325",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M345.853 162.239C348.401 154.451 349.676 150.536 352.225 142.663",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.83 1.83"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M352.515 141.679C352.67 141.219 352.743 140.994 352.888 140.545L354.038 140.47",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M356.017 140.342L358.907 140.16",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.67 1.67"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M359.871 140.096L361.032 140.021L361.55 138.951",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M362.565 136.812L368.119 125.045",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.95 1.95"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M368.616 124.008L369.134 122.938L370.295 122.842",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M372.284 122.66L383.194 121.804",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.71 1.71"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M384.188 121.74L385.349 121.644L386.167 120.734",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M387.463 119.291L391.991 114.21",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.58 1.58"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M392.633 113.482L393.451 112.551L394.612 112.455",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M396.923 112.263L409.667 111.193C412.257 108.23 413.552 106.754 416.143 103.769",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.99 1.99"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M416.95 102.817C417.282 102.432 417.448 102.25 417.769 101.865L418.587 102.667",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M420.214 104.24C425.063 108.989 427.467 111.385 432.357 116.22",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.98 1.98"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M433.165 117.033L433.984 117.846C434.315 117.472 434.471 117.279 434.802 116.894",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M436.098 115.397C437.911 113.257 438.812 112.252 440.625 110.134",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.58 1.58"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M441.268 109.385L442.086 108.422L443.247 108.326",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M445.475 108.134L458.302 107.064C461.545 103.224 463.161 101.298 466.404 97.4366L472.237 96.9017",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.93 1.93"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M473.356 96.7734L474.517 96.6664L475.035 95.4684",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M476.04 93.1259C478.257 87.9699 479.376 85.3813 481.594 80.1932",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.95 1.95"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M482.101 79.0056L482.619 77.7968",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M304.294 159.382L320.499 158.559C326.985 155.039 330.228 153.264 336.714 149.659L344.816 149.188C348.059 142.503 349.686 139.133 352.929 132.362C356.172 128.853 357.788 127.099 361.031 123.548C364.274 116.701 365.891 113.257 369.134 106.325C375.62 109.053 378.863 110.433 385.349 113.246C388.592 116.327 390.208 117.878 393.451 121.012C399.937 113.738 403.18 110.059 409.666 102.614C412.909 95.4573 414.526 91.9166 417.769 84.6213C424.255 90.8362 427.498 93.9918 433.984 100.378C437.227 107.074 438.843 110.433 442.086 117.215L458.301 115.942C461.544 112.134 463.16 110.219 466.404 106.315C469.647 95.2969 471.273 89.7558 474.516 78.6096C477.749 71.0575 479.376 67.2601 482.619 59.6332",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M335.377 203.796C335.044 203.915 334.694 203.973 334.341 203.968C334.028 204.008 333.709 203.973 333.41 203.867C333.112 203.761 332.84 203.585 332.617 203.354C332.394 203.123 332.226 202.842 332.124 202.533C332.022 202.224 331.99 201.895 332.031 201.571V196.469C331.994 196.143 332.029 195.812 332.131 195.502C332.233 195.191 332.4 194.907 332.621 194.671C332.842 194.435 333.111 194.252 333.408 194.135C333.706 194.019 334.024 193.972 334.341 193.998C334.655 193.956 334.973 193.989 335.272 194.094C335.572 194.199 335.844 194.373 336.068 194.604C336.292 194.834 336.462 195.114 336.565 195.422C336.668 195.731 336.701 196.06 336.662 196.383V201.475C336.681 202.039 336.533 202.595 336.237 203.069C336.341 203.262 336.527 203.294 336.807 203.283H337.035V204.663H336.641C336.365 204.697 336.087 204.628 335.855 204.47C335.623 204.311 335.454 204.072 335.377 203.796V203.796ZM335.16 201.657V196.383C335.16 195.688 334.849 195.431 334.362 195.442C333.875 195.453 333.574 195.72 333.574 196.415V201.678C333.574 202.374 333.885 202.63 334.362 202.62C334.838 202.609 335.16 202.32 335.16 201.625V201.657Z",
    fill: "#263238"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M339.853 196.362H338.258V195.292C339.553 195.292 340.009 194.982 340.33 194.03H341.366V203.743H339.833L339.853 196.362Z",
    fill: "#263238"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M399.793 203.005C399.461 203.132 399.11 203.197 398.756 203.197C398.434 203.225 398.109 203.177 397.806 203.057C397.504 202.937 397.231 202.748 397.009 202.505C396.787 202.261 396.621 201.969 396.524 201.65C396.426 201.331 396.4 200.993 396.446 200.662V195.314C396.401 194.98 396.429 194.639 396.526 194.317C396.623 193.995 396.788 193.699 397.009 193.45C397.229 193.201 397.5 193.005 397.802 192.876C398.104 192.747 398.43 192.688 398.756 192.704C400.259 192.704 401.077 193.592 401.077 195.228V200.577C401.105 201.168 400.957 201.754 400.653 202.256C400.756 202.459 400.943 202.492 401.222 202.481H401.461V203.957H401.057C400.769 203.987 400.481 203.907 400.248 203.731C400.015 203.555 399.852 203.297 399.793 203.005V203.005ZM399.575 200.727V195.164C399.575 194.437 399.264 194.159 398.777 194.169C398.29 194.18 397.99 194.469 397.99 195.239V200.748C397.99 201.475 398.301 201.743 398.777 201.743C399.254 201.743 399.575 201.454 399.575 200.748V200.727Z",
    fill: "#263238"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M402.103 201.903C402.091 201.218 402.221 200.539 402.486 199.912C402.75 199.284 403.143 198.723 403.637 198.266C404.797 196.961 405.129 196.126 405.129 195.217C405.129 194.308 404.828 194.051 404.341 194.062C403.854 194.073 403.544 194.361 403.544 195.132V196.201H402.103V195.207C402.103 193.57 402.88 192.618 404.383 192.596C405.885 192.575 406.662 193.484 406.662 195.121C406.662 196.34 406.186 197.432 404.766 199.036C403.854 200.106 403.616 200.587 403.616 201.293V201.518H406.517V202.983L402.103 203.037V201.903Z",
    fill: "#263238"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M464.684 202.213C464.354 202.348 464.003 202.417 463.648 202.416C462.146 202.416 461.327 201.464 461.327 199.753V194.126C461.327 192.415 462.146 191.42 463.648 191.388C465.15 191.356 465.969 192.329 465.969 194.041V199.678C465.992 200.297 465.841 200.91 465.534 201.443C465.648 201.657 465.824 201.689 466.104 201.678H466.342V203.208H465.938C465.646 203.234 465.356 203.146 465.124 202.962C464.892 202.778 464.735 202.511 464.684 202.213V202.213ZM464.456 199.817V193.966C464.456 193.196 464.156 192.896 463.669 192.896C463.182 192.896 462.881 193.206 462.881 193.966V199.817C462.881 200.577 463.182 200.887 463.669 200.887C464.156 200.887 464.415 200.577 464.415 199.817H464.456Z",
    fill: "#263238"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M466.911 199.678V198.801H468.351V199.753C468.351 200.512 468.652 200.822 469.139 200.822C469.626 200.822 469.937 200.544 469.937 199.592V198.715C469.937 197.72 469.626 197.356 468.9 197.367H468.393V195.827H468.942C469.512 195.827 469.864 195.538 469.864 194.671V193.891C469.864 193.12 469.543 192.821 469.097 192.821C468.652 192.821 468.362 193.131 468.362 193.837V194.543H466.922V193.976C466.922 192.254 467.699 191.281 469.149 191.259C470.6 191.238 471.387 192.147 471.387 193.869V194.329C471.387 195.484 471.056 196.201 470.351 196.522C471.17 196.843 471.47 197.592 471.47 198.715V199.678C471.47 201.4 470.693 202.352 469.191 202.363C467.688 202.373 466.911 201.421 466.911 199.678Z",
    fill: "#263238"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M363.001 141.411C363.001 141.411 347.573 127.729 357.82 118.691C357.82 118.691 362.762 102.645 378.998 104.902C395.234 107.159 387.101 97.671 387.101 97.671C387.101 97.671 396.301 102.645 392.074 106.485C393.344 106.547 394.606 106.242 395.718 105.603C396.829 104.964 397.745 104.017 398.363 102.87C398.363 102.87 401.192 108.068 395.908 110.358C395.908 110.358 402.818 112.165 400.974 116.241C400.974 116.241 396.063 113.545 394.757 123.729C393.452 133.912 377.827 132.425 377.827 132.425L363.001 141.411Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M363.985 144.802C363.985 144.278 360.317 155.82 367.29 154.847C370.595 154.387 365.891 144.802 365.891 144.802H363.985Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M398 113.61C398 113.61 393.856 112.925 393.037 117.889",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M388.188 112.422C386.551 114.626 387.1 117.899 387.1 117.899",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M396.83 106.485C395.313 108.626 393.111 110.142 390.613 110.764",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M377.796 112.197C377.796 112.197 384.448 110.839 383.567 117.899",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M410.413 282.857C410.413 282.857 415.936 312.616 410.413 341.776C404.891 370.936 401.482 464.577 401.482 464.577H367.114V278.204L408.683 276.696L410.413 282.857Z",
    fill: "#999999"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M389.992 322.788C389.992 322.788 388.5 333.079 395.949 330.479C403.399 327.88 408.569 328.779 402.353 334.598C396.136 340.417 387.515 349.231 386.137 381.108C384.759 412.985 382.625 464.544 382.625 464.544H367.653L364.545 346.15L378.149 325.473L384.48 322.756L389.992 322.788Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M410.413 282.857C410.413 282.857 415.936 312.616 410.413 341.776C404.891 370.936 401.482 464.577 401.482 464.577H367.114V278.204L408.683 276.696L410.413 282.857Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M406.268 330.586C406.268 330.586 398.57 328.896 389.991 338.727",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M394.882 286.205C394.882 286.205 394.53 319.366 390.385 331.945C386.241 344.525 380.024 403.551 380.718 464.588H345.19C345.19 464.588 343.118 354.334 341.719 338.053C340.32 321.773 333.088 324.5 343.097 278.215H396.343L394.882 286.205Z",
    fill: "#999999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M388.147 293.308C390.883 293.116 393.38 292.891 395.649 292.656L395.949 298.122C393.587 298.368 390.976 298.603 388.147 298.796V293.308Z",
    fill: "#263238"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M399.513 292.206C403.802 291.682 406.911 291.136 408.589 290.826L409.304 296.228C407.356 296.592 404.02 297.159 399.513 297.715V292.206Z",
    fill: "#263238"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M341.201 297.598L342.009 292.249C347.832 292.923 353.407 293.372 358.722 293.629L358.369 299.052C352.951 298.753 347.211 298.304 341.201 297.598Z",
    fill: "#263238"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M362.762 293.811C370.865 294.078 378.18 293.928 384.521 293.575V299.052C380.501 299.266 376.087 299.405 371.341 299.405C368.544 299.405 365.622 299.352 362.597 299.245L362.762 293.811Z",
    fill: "#263238"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M461.504 235.341L470.249 229.896C470.249 229.896 473.927 219.948 478.538 217.242C483.148 214.535 487.738 212.043 488.899 212.717C490.059 213.391 488.671 215.659 485.676 217.916C483.811 219.328 489.241 216.932 496.203 213.637C500.348 211.647 505.134 208.877 505.87 210.075C508.574 214.429 494.742 219.97 494.742 219.97C494.742 219.97 499.488 219.734 497.643 223.35C497.643 223.35 498.338 226.741 496.721 227.875L494.887 230.185C494.133 232.466 492.678 234.431 490.743 235.78C486.571 238.178 481.927 239.572 477.159 239.855L465.659 248.167L461.504 235.341Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M491.882 220.408C491.882 220.408 482.101 222.441 482.619 224.687C483.138 226.934 486.173 225.35 486.173 225.35C486.173 225.35 482.941 226.484 483.293 227.725C483.645 228.966 485.935 228.945 485.935 228.945C485.935 228.945 482.941 229.651 483.293 231.084C483.645 232.517 485.635 233.009 487.282 232.785C488.929 232.56 490.193 231.982 490.66 232.838C491.126 233.694 486.163 232.325 483.293 234.421",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M484.101 218.707C483.948 219.961 483.44 221.141 482.64 222.098C481.449 223.232 482.485 227.072 478.112 231.255",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M494.037 224.302L488.598 224.976",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M493.602 228.538L488.598 228.966",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M440.792 241.085C448.387 238.946 457.567 233.095 461.98 230.068C462.235 229.887 462.529 229.775 462.837 229.743C463.144 229.711 463.454 229.76 463.738 229.885C464.022 230.01 464.271 230.207 464.462 230.457C464.653 230.708 464.779 231.005 464.83 231.319C465.327 235.459 466.902 242.508 472.207 244.423C479.801 247.183 472.549 251.44 467.72 252.874C462.892 254.307 428.348 271.593 417.987 269.229C407.626 266.865 404.176 265.154 399.337 254.82C394.499 244.487 396.913 194.639 396.913 194.639L411.418 190.906C411.418 190.906 415.21 194.415 417.055 217.916C418.899 241.417 421.935 244.359 421.935 244.359C421.935 244.359 431.146 237.331 428.732 244.123C428.711 244.123 438.181 241.813 440.792 241.085Z",
    fill: "#7846D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M423.872 248.156C423.872 248.156 420.131 261.057 417.313 260.073C414.495 259.089 415.241 255.569 419.903 248.156",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M411.449 190.906C404.725 184.306 394.871 177.685 374.512 176.326C354.152 174.968 325.815 180.059 324.779 188.2C323.743 196.34 335.482 239.973 335.482 279.06C335.482 284.826 336.176 291.265 347.915 291.265C359.654 291.265 413.511 295.33 414.226 282.108C414.941 268.887 411.47 255.666 412.506 236.678C413.542 217.691 416.63 195.998 411.449 190.906Z",
    fill: "#7846D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M330.498 182.562C330.498 182.562 322.043 185.162 320.199 198.276C318.355 211.391 310.304 240.989 313.298 241.674C316.293 242.358 306.16 247.546 309.838 255.237C313.516 262.929 330.094 287.778 339.761 285.071C349.428 282.365 348.961 266.983 345.977 264.276C342.993 261.57 332.829 255.89 332.829 255.89C332.829 255.89 335.813 254.082 332.135 250.691C328.457 247.3 334.798 252.403 336.735 240.968C339.035 227.415 347.096 207.968 342.258 196.222",
    fill: "#7846D1"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M330.498 182.562C330.498 182.562 322.043 185.162 320.199 198.276C318.355 211.391 310.304 240.989 313.298 241.674C316.293 242.358 306.16 247.546 309.838 255.237C313.516 262.929 330.094 287.778 339.761 285.071C349.428 282.365 348.961 266.983 345.977 264.276C342.993 261.57 332.829 255.89 332.829 255.89C332.829 255.89 335.813 254.082 332.135 250.691C328.457 247.3 334.798 252.403 336.735 240.968C339.035 227.415 347.096 207.968 342.258 196.222",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M331.016 243.685C331.016 243.685 317.899 240.476 314.438 245.942C310.978 251.408 319.888 244.819 328.436 247.076",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M349.998 269.454C347.926 267.924 342.983 265.271 339.761 268.384C336.539 271.497 328.83 273.347 329.286 275.722C329.742 278.097 332.622 278.781 337.803 276.182C342.983 273.583 338.704 276.856 339.637 282.055C340.569 287.253 341.326 291.981 345.377 291.093C345.377 291.093 345.739 293.351 349.428 292.334C349.428 292.334 352.184 294.666 356.556 292.602C356.556 292.602 358.981 295.158 362.545 290.751C366.109 286.344 363.913 285.253 363.913 285.253C363.913 285.253 362.307 280.15 358.732 285.253C358.732 285.253 359.354 278.942 355.748 274.984C353.961 273.002 352.039 271.154 349.998 269.454V269.454Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M346.93 289.532C346.93 289.532 352.764 285.691 351.5 283.434C350.236 281.177 345.511 285.916 345.511 285.916C345.511 285.916 346.205 284.696 344.827 282.825",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M351.147 290.805C351.147 290.805 359.965 287.97 357.944 285.253C356.152 282.857 352.36 285.606 352.36 285.606",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M362.876 286.205C362.876 286.205 361.944 288.922 357.81 291.554",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M348.246 278.204C349.494 280.19 351.232 281.796 353.282 282.857",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M331.016 254.82C331.016 254.82 323.597 251.087 317.898 253.964",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M387.111 183.279L381.184 181.076L374.512 183.279C374.512 183.279 378.998 190.232 380.811 190.564C380.811 190.564 387.308 242.637 389.359 266.951C391.411 291.265 390.737 293.511 390.737 293.511L399.71 301.096L406.268 291.532C406.268 291.532 402.818 253.291 398.332 230.56C395.551 216.662 391.266 203.131 385.557 190.222C385.557 190.222 388.199 186.724 387.111 183.279Z",
    fill: "#7846D1"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M387.111 183.279L381.184 181.076L374.512 183.279C374.512 183.279 378.998 190.232 380.811 190.564C380.811 190.564 387.308 242.637 389.359 266.951C391.411 291.265 390.737 293.512 390.737 293.512L399.71 301.096L406.268 291.533C406.268 291.533 402.818 253.291 398.332 230.56C395.551 216.662 391.266 203.131 385.557 190.222C385.557 190.222 388.199 186.724 387.111 183.279Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M387.111 183.279L381.184 181.076L374.512 183.279C374.512 183.279 378.998 190.232 380.811 190.564C380.811 190.564 387.308 242.637 389.359 266.951C391.411 291.265 390.737 293.511 390.737 293.511L399.71 301.096L406.268 291.532C406.268 291.532 402.818 253.291 398.332 230.56C395.551 216.662 391.266 203.131 385.557 190.222C385.557 190.222 388.199 186.724 387.111 183.279Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M387.815 165.447C387.815 165.447 386.645 173.267 389.556 178.626C389.556 178.626 383.257 181.471 380.552 181.835C377.848 182.199 363.975 173.662 363.975 173.662C365.788 164.677 366.436 155.483 365.902 146.321C365.011 131.238 381.578 155.745 381.578 155.745L389.546 163.233L387.815 165.447Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M390.385 166.164C390.385 166.164 390.551 171.245 383.567 171.073C376.584 170.902 369.642 160.184 368.471 157.51C367.3 154.835 365.912 142.256 365.912 142.256L383.526 147.369L392.074 165.447L390.385 166.164Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M387.815 165.447C387.815 165.447 386.645 173.267 389.556 178.626C389.556 178.626 383.257 181.471 380.552 181.835C377.848 182.199 363.975 173.662 363.975 173.662C365.788 164.677 366.436 155.483 365.902 146.321C365.011 131.238 381.578 155.745 381.578 155.745L389.546 163.233L387.815 165.447Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M388.551 174.743C388.551 174.743 385.101 180.851 381.185 181.075C377.268 181.3 364.151 168.239 361.395 170.228C359.677 171.568 358.424 173.444 357.82 175.577L369.549 189.922C369.549 189.922 378.138 182.348 381.589 182.573C385.039 182.797 392.457 189.922 392.457 189.922V179.535C392.457 179.535 390.178 172.379 388.551 174.743Z",
    fill: "#7846D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M393.556 119.899C393.556 119.899 398.384 134.522 397.431 138.245C397.431 138.245 401.928 165.96 391.214 168.196C382.76 169.929 374.398 161.543 371.207 157.863C370.339 156.856 369.673 155.682 369.249 154.408L367.176 148.139C367.176 148.139 362.959 148.46 360.39 142.62C357.82 136.779 363.053 131.11 367.104 139.956C367.104 139.956 370.274 131.013 370.036 127.419C369.798 123.825 374.367 124.702 375.31 121.151C375.31 121.13 386.148 122.937 393.556 119.899Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M393.556 119.899C393.556 119.899 398.384 134.522 397.431 138.245C397.431 138.245 401.928 165.96 391.214 168.196C382.76 169.929 374.398 161.543 371.207 157.863C370.339 156.856 369.673 155.682 369.249 154.408L367.176 148.139C367.176 148.139 362.959 148.46 360.39 142.62C357.82 136.779 363.053 131.11 367.104 139.956C367.104 139.956 370.274 131.013 370.036 127.419C369.798 123.825 374.367 124.702 375.31 121.151C375.31 121.13 386.148 122.937 393.556 119.899Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M393.037 140.769L398.756 148.204C398.89 148.381 398.981 148.59 399.02 148.811C399.059 149.032 399.046 149.26 398.982 149.475C398.918 149.69 398.805 149.886 398.652 150.047C398.499 150.207 398.311 150.327 398.104 150.396L394.042 151.873",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M393.037 140.769L398.756 148.204C398.89 148.381 398.981 148.59 399.02 148.811C399.059 149.032 399.046 149.26 398.982 149.475C398.918 149.69 398.805 149.886 398.652 150.047C398.499 150.207 398.311 150.327 398.104 150.396L394.042 151.873",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M384.718 154.846C384.718 154.846 386.49 158.612 392.416 155.285",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M392.063 140.469C392.239 144.171 390.478 147.251 388.136 147.358C385.795 147.465 383.754 144.556 383.578 140.865C383.401 137.175 385.163 136.105 387.504 135.998C389.846 135.891 391.887 136.768 392.063 140.469Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M402.849 139.635C403.025 143.336 401.616 146.406 399.741 146.492C397.865 146.577 396.135 143.657 395.959 139.956C395.783 136.255 397.213 135.217 399.13 135.121C401.046 135.025 402.673 135.934 402.849 139.635Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M383.599 135.089C383.599 135.089 386.147 131.238 390.665 134.18",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M396.032 134.169C396.836 133.218 397.934 132.583 399.141 132.372",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M383.598 140.844C382.103 141.276 380.568 141.548 379.019 141.657C375.506 141.304 365.933 136.501 365.933 136.501",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M395.907 139.346L392.239 139.999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M390.001 140.919C389.898 142.064 389.235 142.93 388.509 142.866C387.784 142.802 387.297 141.796 387.39 140.726C387.484 139.657 388.167 138.715 388.882 138.78C389.597 138.844 390.105 139.774 390.001 140.919Z",
    fill: "#263238"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M398.933 139.668C398.829 140.737 398.332 141.646 397.814 141.593C397.296 141.539 396.964 140.62 397.068 139.507C397.171 138.395 397.658 137.539 398.176 137.582C398.694 137.624 399.026 138.566 398.933 139.668Z",
    fill: "#263238"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M357.996 268.512C359.809 263.677 371.984 264.479 371.984 264.479",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M387.039 270.951C374.139 274.16 360.1 276.46 358.245 271.935",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M409.304 264.479C409.304 264.479 407.957 264.929 405.709 265.645",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M674.331 464.577H219.251V402.021C219.251 402.021 307.434 366.721 421.292 366.721C560.1 366.774 674.331 464.577 674.331 464.577Z",
    fill: "#7846D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M486.826 384.221L433.103 376.744L378.459 386.275L432.181 393.763L486.826 384.221Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M480.246 383.697L430.327 376.744L379.547 385.601L429.467 392.554L480.246 383.697Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M486.826 381.611L436.907 374.658L386.127 383.515L436.047 390.468L486.826 381.611Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M384.262 420.11C393.732 420.11 401.409 418.491 401.409 416.494C401.409 414.498 393.732 412.879 384.262 412.879C374.792 412.879 367.114 414.498 367.114 416.494C367.114 418.491 374.792 420.11 384.262 420.11Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M394.177 415.51C394.177 416.515 388.644 417.328 381.806 417.328C374.968 417.328 369.445 416.515 369.445 415.51V391.549C369.445 390.543 374.978 389.73 381.806 389.73C388.634 389.73 394.177 390.543 394.177 391.549V415.51Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M394.177 391.549C394.177 392.554 388.644 393.367 381.806 393.367C374.968 393.367 369.445 392.554 369.445 391.549C369.445 390.543 374.978 389.73 381.806 389.73C388.634 389.73 394.177 390.543 394.177 391.549Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M392.685 413.242C392.358 413.249 392.04 413.134 391.788 412.917C391.537 412.701 391.37 412.399 391.317 412.065C391.294 411.884 391.307 411.699 391.354 411.522C391.401 411.346 391.482 411.181 391.592 411.037C391.703 410.894 391.84 410.774 391.995 410.686C392.151 410.598 392.322 410.543 392.499 410.525C392.809 410.525 400.311 409.327 400.311 402.352C400.311 400.598 399.855 399.411 398.964 398.812C397.296 397.742 394.177 398.576 393.213 398.972C392.876 399.111 392.5 399.11 392.162 398.971C391.825 398.832 391.552 398.564 391.4 398.223C391.334 398.056 391.301 397.876 391.303 397.695C391.305 397.514 391.343 397.335 391.413 397.17C391.484 397.004 391.586 396.855 391.714 396.731C391.841 396.607 391.992 396.51 392.157 396.448C392.685 396.234 397.337 394.458 400.508 396.555C402.217 397.689 403.088 399.635 403.088 402.352C403.088 409.84 396.415 412.739 392.882 413.231L392.685 413.242Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M410.454 397.646C409.636 398.459 409.076 399.229 409.221 399.379C409.366 399.529 410.154 398.973 410.983 398.16C411.811 397.347 412.361 396.576 412.216 396.437C412.07 396.298 411.283 396.844 410.454 397.646Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M414.91 390.297C411.522 393.624 409.574 397.101 410.558 398.063C411.542 399.026 415.096 397.122 418.484 393.785L440.315 372.337C443.703 369.01 445.651 365.523 444.667 364.561C443.682 363.598 440.139 365.502 436.751 368.839L414.91 390.297Z",
    fill: "#7846D1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M437.113 375.493L436.212 376.381C435.58 375.857 434.958 375.311 434.357 374.701C433.756 374.092 433.176 373.493 432.647 372.883L433.549 371.995C434.077 372.605 434.647 373.214 435.258 373.813C435.87 374.413 436.491 374.969 437.113 375.493Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M441.983 364.914C441.983 364.914 440.47 363.951 437.01 366.582C433.549 369.214 430.327 373.76 428.721 373.61",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M399.938 409.199C399.938 409.199 402.455 402.92 402.455 399.711C402.455 396.502 409.003 385.687 413.852 383.783C418.701 381.879 435.03 373.931 436.222 377.151C437.414 380.371 430.068 384.361 428.524 385.109C426.807 386.222 425.191 387.493 423.695 388.907C423.695 388.907 431.166 387.366 431.984 384.928C432.803 382.489 435.093 379.237 436.336 381.323C437.579 383.409 437.009 388.714 435.072 392.79V395.539C435.072 395.539 437.196 398.748 434.885 401.412L433.103 403.305C433.103 403.305 436.212 406.514 431.984 409.188C431.984 409.188 433.922 412.034 430.441 414.868C430.441 414.868 423.105 418.473 418.473 419.607C413.842 420.741 409.791 427.576 409.791 427.576L399.938 409.199Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M258.063 300.464L270.165 272.577L262.374 249.215L261.597 222.419L282.92 210.075L301.746 206.802L309.423 211.391L312.615 219.028C312.615 219.028 322.188 239.01 320.707 242.85C319.225 246.691 318.127 250.338 318.127 250.338C318.127 250.338 322.644 260.714 325.317 264.009C327.99 267.304 319.702 265.303 318.728 271.24C317.754 277.177 318.914 292.934 311.806 293.65C304.699 294.367 300.409 292.089 299.756 298.282C299.104 304.476 291.81 320.2 291.81 320.2L258.063 300.464Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M317.433 188.981C316.397 185.386 306.419 190.382 305.383 198.084C305.383 198.084 304.108 186.317 300.814 185.194C297.933 184.22 293.955 189.558 295.395 195.891C295.395 195.891 284.63 190.05 281.159 191.409C278.589 192.414 277.688 197.592 283.231 202.106C283.231 202.106 249.578 194.383 251.547 224.644C251.547 224.644 233.042 238.882 267.275 279.327C267.275 279.327 275.398 277.466 277.636 276.118C278.931 275.337 289.758 266.491 289.758 266.491C286.65 265.346 281.241 262.073 279.77 258.126C277.905 253.13 280.402 247.161 284.951 246.359C287.676 245.878 289.22 247.129 291.167 249.376C291.167 249.376 286.681 243.524 286.961 241.257C287.313 238.422 294.089 235.416 294.587 232.603C294.814 231.276 291.799 228.666 292.597 227.565C296.659 221.97 316.065 228.452 314.076 209.904C312.086 191.355 318.883 194.019 317.433 188.981Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M316.718 248.884C316.718 250.349 316.438 251.547 315.982 251.558C315.526 251.569 315.143 250.392 315.101 248.926C315.06 247.461 315.381 246.263 315.827 246.252C316.272 246.242 316.676 247.44 316.718 248.884Z",
    fill: "#263238"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M313.319 243.621C313.319 243.621 314.501 239.866 316.873 239.62",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M287.894 214.728C299.519 215.68 289.904 198.063 289.904 198.063",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M258.405 222.975C258.405 222.975 267.554 209.24 284.401 214.043",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M303.818 206.855C304.958 212.952 303.818 221.103 290.245 222.087",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M301.497 200.084C301.968 201.01 302.376 201.967 302.72 202.951",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M314.055 464.577C314.055 464.577 324.54 353.094 312.107 332.053C299.674 311.012 262.508 286.323 249.215 297.02C203.088 334.31 202.932 366.155 200 464.556L314.055 464.577Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M303.932 328.041C303.932 328.041 318.593 332.02 326.726 354.783C334.217 375.675 347.832 403.219 356.919 416.943C357.637 417.996 358.629 418.817 359.781 419.313C360.932 419.809 362.195 419.959 363.425 419.746C367.425 419.094 375.05 418.591 382.355 414.494C389.121 410.696 395.099 406.535 402.621 407.669C410.143 408.803 414.858 416.024 413.646 426.453C412.485 436.401 369.165 462.277 343.584 462.277C322.717 462.277 303.642 403.144 297.27 385.516C290.898 367.887 284.246 329.207 303.932 328.041Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M296.213 330.416C298.121 328.959 300.41 328.131 302.782 328.041",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M291.105 338.738C291.505 337.327 292.05 335.964 292.732 334.673",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M312.532 422.816C306.336 410.733 300.856 398.273 296.12 385.505C292.152 374.52 288.069 355.372 290.318 342.226",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M303.445 324.094C303.445 324.094 309.237 315.376 303.445 308.166C297.653 300.956 271.222 285.382 261.337 289.222C260.592 289.474 259.903 289.88 259.314 290.415C258.724 290.949 258.246 291.602 257.907 292.332C257.568 293.063 257.376 293.857 257.342 294.666C257.309 295.475 257.434 296.283 257.711 297.041C257.711 297.041 277.583 297.94 303.445 324.094Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M300.233 321.623C301.052 322.414 301.881 323.227 302.71 324.072",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M264.498 298.646C271.367 300.785 282.475 305.824 295.685 317.451",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M257.007 297.02C258.171 297.111 259.328 297.29 260.467 297.555",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M362.69 434.401C362.69 434.401 362.69 428.154 359.509 426.442C356.328 424.731 358.929 434.401 355.748 442.37",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M329.109 366.176C329.109 366.176 331.72 366.454 334.031 392.608",
    stroke: "#7F7F7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M289.706 266.427L291.924 266.855C291.997 270.073 292.735 273.239 294.089 276.14C296.161 280.119 299.104 280.878 306.015 288.623C312.459 295.833 315.423 291.137 315.796 290.463C315.447 291.312 314.892 292.054 314.184 292.616C313.476 293.178 312.639 293.542 311.755 293.672C304.657 294.389 300.358 292.11 299.705 298.304C298.565 293.511 294.856 287.746 291.924 280.536C290.142 276.072 289.383 271.243 289.706 266.427V266.427Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M292.732 261.924C293.55 256.992 288.587 246.948 291.188 249.28C293.789 251.612 297.177 260.212 301.228 263.485C305.279 266.759 304.896 274.428 310.688 271.209C313.212 269.756 316.184 269.373 318.977 270.139C318.845 270.484 318.751 270.842 318.697 271.209C317.733 277.177 318.883 292.902 311.776 293.619C309.728 293.776 307.674 293.822 305.621 293.758C301.601 289.415 295.861 282.964 293.664 279.221C290.111 273.22 291.924 266.855 292.732 261.924Z",
    fill: "#263238"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M317.381 276.182C317.381 276.182 313.744 274.546 313.817 272.193",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1648_474",
    x1: 137.887,
    y1: 122.162,
    x2: 300.211,
    y2: 397.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C78ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B23A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareersHero);
export default __webpack_public_path__ + "static/media/careers-hero.16e45da7ead8f0178c05b4b47041a555.svg";
export { ForwardRef as ReactComponent };